import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import moment from 'moment';
import { push } from 'react-router-redux';
import { List } from 'immutable';

import ItemListC from './itemList';
import * as viajesActions from 'modules/viajes/action';
import * as asignacionActions from 'modules/asignacion/action';
import * as generalActions from 'modules/general/action';
import { SeleccionadorC, EliminarConfirmacionC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';

moment.locale('es');

import areIntlLocalesSupported from 'intl-locales-supported';

let DateTimeFormat;
if (areIntlLocalesSupported(['es', 'es-AR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/es');
  require('intl/locale-data/jsonp/es-AR');
}

@connect((store) => ({
  viajeBuscado: store.getIn(['viajes', 'buscado']),
  diaBuscando: store.getIn(['viajes', 'diaBuscando']),
  viajesManana: store.getIn(['viajes', 'manana']),
  eliminarId: store.getIn(['viajes', 'eliminarId']),
  viajeId: store.getIn(['asignaciones', 'viajeId']),
  openModal: store.getIn(['asignaciones', 'openModal']),
}))
export default class extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(generalActions.dashboard_changeTitle('VIAJES'));
    if (this.props.viajesManana.size == 0) this.props.dispatch(viajesActions.get());
    if (!moment(this.props.diaBuscando).isValid()) this.buscarViaje(false, new Date());
  };
  buscarViaje(e, diaBuscando) {
    this.props.dispatch(viajesActions.setState({ diaBuscando }));
    this.props.dispatch(viajesActions.buscar(diaBuscando));
  }
  seleccionarChofer = (query, viajeId) => {
    if (!query) this.props.dispatch(generalActions.seleccionador_open('_chofer'));
    if (viajeId) this.props.dispatch(asignacionActions.setState({ viajeId }));
    this.props.dispatch(asignacionActions.seleccionarChofer(query));
  };
  quitarChofer = (viajeId) => this.props.dispatch(asignacionActions.asignar({ choferId: 'false', viajeId }));
  seleccionarVehiculo = (query, viajeId) => {
    if (!query) this.props.dispatch(generalActions.seleccionador_open('vehiculos'));
    if (viajeId) this.props.dispatch(asignacionActions.setState({ viajeId }));
    this.props.dispatch(asignacionActions.seleccionarVehiculo(query));
  };
  quitarVehiculo = (viajeId) => this.props.dispatch(asignacionActions.asignar({ vehiculoId: 'false', viajeId }));
  asignar = (choferId, viajeId) => this.props.dispatch(asignacionActions.asignar({ choferId, viajeId }));
  confirmDelete = () => {
    this.props.dispatch(viajesActions.delete_(this.props.eliminarId));
    this.props.dispatch(viajesActions.setState({ eliminarId: false }));
    setTimeout(() => this.buscarViaje(false, new Date()), 1000);
  };
  eliminarViaje = (viajeId) => this.props.dispatch(viajesActions.setState({ eliminarId: viajeId ? viajeId : false }));
  editarViaje = (viajeId) => (viajeId ? this.props.dispatch(push('/dashboard/viajes/add/' + viajeId)) : this.props.dispatch(push('/dashboard/viajes/add/new')));
  reservasViaje = (viajeId) => (viajeId ? this.props.dispatch(push('/dashboard/reservas/pasajeros/' + viajeId)) : this.props.dispatch(push('/dashboard/reservas/pasajeros/new')));
  render = () => {
    return (
      <Row className="rowContainer">
        <Col md={{ size: 10, offset: 1 }}>
          <Row style={{ alignItems: 'center', paddingTop: 20 }}>
            <Col md={{ size: 1, offset: 3 }} style={{ textAlign: 'right' }}>
              <FontAwesome name="calendar" style={{ fontSize: '40px' }} size="2x" />
            </Col>
            <Col md="5">
              <MaterialUI.DatePicker
                fullWidth={true}
                value={this.props.diaBuscando ? this.props.diaBuscando : undefined}
                autoOk={true}
                DateTimeFormat={DateTimeFormat}
                locale="es-AR"
                onChange={this.buscarViaje.bind(this)}
                name="diaBuscando"
                hintText="Seleccione un dia"
                floatingLabelText="Dia"
              />
            </Col>
            <Col md="2">
              <MaterialUI.RaisedButton secondary={true} label="HOY" className="fullWidthComponent noPadding" onTouchTap={() => this.buscarViaje(false, new Date())} />
              <MaterialUI.RaisedButton secondary={true} label="MAÑANA" className="fullWidthComponent noPadding" onTouchTap={() => this.buscarViaje(false, moment().add(1, 'day').toDate())} />
            </Col>
          </Row>
          <MaterialUI.Paper zDepth={2} className="container">
            {this.props.diaBuscando && (
              <Row>
                <Col md="12 noPadding">
                  <MaterialUI.AppBar
                    title={`VIAJES DEL ${moment(this.props.diaBuscando).format('DD/MM/YY')} (${moment(this.props.diaBuscando).format('dddd').toUpperCase()})`}
                    iconElementLeft={<div />}
                  />
                  <MaterialUI.List className="noPadding">
                    {this.props.viajeBuscado.map((viaje) => (
                      <ItemListC
                        key={viaje.get('id')}
                        viaje={viaje}
                        seleccionarChofer={this.seleccionarChofer}
                        quitarChofer={this.quitarChofer}
                        seleccionarVehiculo={this.seleccionarVehiculo}
                        quitarVehiculo={this.quitarVehiculo}
                        asignar={this.asignar}
                        eliminarViaje={this.eliminarViaje}
                        editarViaje={this.editarViaje}
                        reservasViaje={this.reservasViaje}
                      />
                    ))}
                  </MaterialUI.List>
                </Col>
              </Row>
            )}
          </MaterialUI.Paper>
          <Row>
            <Col md="12" className="pt-30">
              <p>
                <FontAwesome name="warning" className="iconAlert iconInfo" /> Solo se podran eliminar los viajes que no posean ninguna reserva
              </p>
            </Col>
          </Row>
        </Col>
        <MaterialUI.Dialog
          title={this.props.openModal ? this.props.openModal.get('title') : 'Conflicto'}
          open={!!this.props.openModal}
          onRequestClose={() => this.props.dispatch(asignacionActions.setState({ openModal: false }))}
        >
          {this.props.openModal && <h4>{this.props.openModal.get('message')}</h4>}
          <Col>
            <MaterialUI.RaisedButton
              secondary={true}
              label="Continuar de todos modos"
              className="fullWidthComponent noPadding"
              onTouchTap={() => {
                this.props.openModal && this.props.dispatch(asignacionActions.asignar({ vehiculoId: this.props.openModal.get('vehiculoId') }));
                this.props.dispatch(asignacionActions.setState({ openModal: false }));
              }}
            />
          </Col>
          {this.props.openModal && this.props.openModal.get && this.props.openModal.get('error') == 101 && (
            <Col>
              <MaterialUI.RaisedButton
                primary={true}
                label="Asignar asientos del vehiculo al viaje"
                className="fullWidthComponent noPadding"
                onTouchTap={() => {
                  this.props.dispatch(viajesActions.set({ cantAsientos: this.props.openModal.get('cantAsientos') }, this.props.openModal.get('viajeId')));
                  this.props.dispatch(asignacionActions.asignar({ vehiculoId: this.props.openModal.get('vehiculoId') }));
                  this.props.dispatch(asignacionActions.setState({ openModal: false }));
                }}
              />
            </Col>
          )}
          <Col>
            <MaterialUI.RaisedButton
              secondary={true}
              label="Cancelar"
              className="fullWidthComponent noPadding"
              onTouchTap={() => this.props.dispatch(asignacionActions.setState({ openModal: false }))}
            />
          </Col>
        </MaterialUI.Dialog>
        <SeleccionadorC
          listComponent={listComponentChofer}
          searchText="Buscar por DNI, Email, Nombre o Apellido"
          buscar={(query) => this.seleccionarChofer(query)}
          title="Seleccione un chofer"
          nameId="_chofer"
        />
        <SeleccionadorC
          listComponent={listComponentVehiculo}
          searchText="Buscar por nombre o patente"
          buscar={(query) => this.seleccionarVehiculo(query)}
          title="Seleccione un vehiculo"
          nameId="vehiculos"
          data={{ lista: this.props.viajeBuscado, viajeId: this.props.viajeId }}
        />
        {checkPermissions(['admin', 'administrador_viajes']) && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={() => this.editarViaje()}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={this.props.eliminarId} cancelar={this.eliminarViaje} confirmar={this.confirmDelete} />
      </Row>
    );
  };
}

const listComponentChofer = (item, dispatch, close) => {
  return (
    <MaterialUI.ListItem
      key={item.get('id')}
      onTouchTap={() => dispatch(asignacionActions.asignar({ choferId: item.get('id') })) && close()}
      primaryText={
        <Row>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="user" />
              </Col>
              <Col md="9">
                <p>
                  <span className="title blue">{item.get('apellido')}</span>
                  <span className="bolder"> {item.get('nombre')} </span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="address-card-o" />
              </Col>
              <Col md="9">
                <p className="bolder"> {item.get('documento')} </p>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

const listComponentVehiculo = (item, dispatch, close, viajeData) => {
  const selectVehicle = () => {
    if (!List.isList(viajeData.lista)) return alert('Error en seleccionar vehiculo.');
    const viaje = viajeData.lista.find((v) => v.get('id') == viajeData.viajeId);
    let asientosViaje = viaje ? viaje.get('cantAsientos') : 0,
      cantReservas = viaje ? viaje.get('cantReservas') : 0;
    if (asientosViaje !== item.get('cantAsientos')) {
      dispatch(
        asignacionActions.setState({
          openModal: {
            error: 101,
            cantAsientos: item.get('cantAsientos'),
            viajeId: viajeData.viajeId,
            title: 'La cantidad de asientos del viaje no coincide con los del vehiculo',
            message: `El viaje tiene ${asientosViaje} asientos y el vehiculo ${item.get('cantAsientos')}.`.concat(
              cantReservas > item.get('cantAsientos') ? `\n Hay ${cantReservas} reservas y el vehiculo posee ${item.get('cantAsientos')} asientos.` : '',
            ),
            vehiculoId: item.get('id'),
          },
        }),
      );
      return close();
    }
    dispatch(asignacionActions.asignar({ vehiculoId: item.get('id') })) && close();
  };
  return (
    <MaterialUI.ListItem
      key={item.get('id')}
      onTouchTap={() => selectVehicle()}
      primaryText={
        <Row>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="bus" />
              </Col>
              <Col md="9">
                <p>
                  <span className="title blue">{item.get('nombre')}</span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col md="6">
            <Row>
              <Col md="3">
                <FontAwesome className="iconBar" name="address-card-o" />
              </Col>
              <Col md="9">
                <p className="bolder"> {item.get('patente')} </p>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};



// WEBPACK FOOTER //
// src/modules/asignacion/components/main.js